// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"51b69759","83":"c0277ffe","89":"3383b52e","140":"3a58dd1a","254":"675ce91a","630":"bdafaded"}[chunkId] + ".chunk.css";
};